import { Injectable } from '@angular/core';
import { SupabaseDatabaseService } from './supabase-database.service';
import TYPES from '../constants/types';

@Injectable({
  providedIn: 'root'
})
export class FeelingService<Feeling> extends SupabaseDatabaseService<Feeling> {

  async getByFeelingLabel(label: string): Promise<Feeling>{
    const { data, error } = await this.supabase
    .from(TYPES.DATABASE.TABLES.FEELINGS)
    .select('*')
    .eq('label', label.trim())
    .maybeSingle();

    if (error) {
      console.error(`Erro ao buscar Feeling com o label ${label} em '${TYPES.DATABASE.TABLES.FEELINGS}':`,
        error);
      throw new Error(error.message);
    }
    return (data as Feeling);

  }

  async getAllSystemFeelings(): Promise<Feeling[]>{
    const { data, error } = await this.supabase
    .from(TYPES.DATABASE.TABLES.FEELINGS)
    .select('*')
    .eq('provider', 'system');

    if (error) {
      console.error(`Erro ao buscar System Feelings em '${TYPES.DATABASE.TABLES.FEELINGS}':`,
        error);
      throw new Error(error.message);
    }
    return (data as Feeling[]) || [];

  }
  
  async getAllCustomFeelingsFromUser(userId: string): Promise<Feeling[]>{
    const { data, error } = await this.supabase
    .from(TYPES.DATABASE.TABLES.FEELINGS)
    .select(`
      id,
      label,
      provider,
      created_at,
      updated_at,
      users_feelings!inner(user_id)
    `)
    .eq('provider', 'custom')
    .eq('users_feelings.user_id', userId);

    if (error) {
      console.error(`Erro ao buscar Custom Feelings em '${TYPES.DATABASE.TABLES.FEELINGS}':`,
        error);
      throw new Error(error.message);
    }
    return (data as Feeling[]) || [];

  }

  async deleteFeelingFromUser(feelingId: string, userId: string): Promise<void> {
    const { error } = await this.supabase
      .from(TYPES.DATABASE.TABLES.USERS_FEELINGS)
      .delete()
      .eq('user_id', userId)
      .eq('feeling_id', feelingId);

    if (error) {
      console.error(`Erro ao deletar feeling '${feelingId}' from user ${userId}:`, error);
      throw new Error(error.message);
    }
  } 

}
